import { ReactNode } from "react";
import Link from "src/components/buttons/LinkButton";
import tw from "src/utils/tw";

interface Props {
  to?: string;
  className?: string;
  onClick?: () => void;
  children?: ReactNode;
  isPreview?: boolean;
}

export default function ItemContentComponent(props: Props) {
  const classNames = tw(
    "text-dark",
    "block",
    "flex-1",
    "hover:text-inherit",
    props.className
  );

  if (props.to) {
    return (
      <Link to={props.to} className={classNames} isPreview={props.isPreview}>
        {props.children}
      </Link>
    );
  }

  return (
    <div className={classNames} onClick={props.onClick}>
      {props.children}
    </div>
  );
}
